"use strict";
/**
 * Generic Utility Types
 *
 * Reusable generic types used across the application
 */
Object.defineProperty(exports, "__esModule", { value: true });
